app.controller('studentCarouselCtrl', [
    '$scope', function ($scope) {

    	$scope.touchStartPoint = { x: 0, y: 0 };
    	$scope.touchStartContentOffset = { x: 0, y: 0};
    	$scope.contentOffset = { x: 0, y: 0 };

        $scope.disablePanning = false;

    	$scope.startTime = 0.0;

        $scope.enabledPages = [ true, true, true, false, false ];

        function isContainedInMdContent(elem) {
            var child = elem;
            do {
                var tagName = child.parentElement.tagName.toLowerCase();
                if (tagName === "md-content") {
                    return true;
                }
                child = child.parentElement;
            } while (child && child.parentElement);
            return false;
        }

    	$scope.onTouchStart = function(evt) {
    		$scope.numPages = $scope.elem.children.length;

    		$scope.startTime = performance.now();

    		// Register the starting point
    		var touch = evt.touches[0];
            console.dir(touch);
    		$scope.touchStartPoint = { x: touch.screenX, y: touch.screenY };
    		$scope.touchStartContentOffset = JSON.parse(JSON.stringify($scope.contentOffset));

            // If the start touch is inside an md-content, discard it.
            $scope.disablePanning = isContainedInMdContent(touch.target);
            console.log("studentCarouselCtrl#onTouchStart: disablePanning = " + $scope.disablePanning);
    	}

    	$scope.onTouchEnd = function(evt) {
    		if ($scope.disablePanning) {
    			return;
    		}

            if ($scope.lastX !== undefined) {
                $scope.snap();
                $scope.lastX = undefined;
            }
    	}

    	$scope.onTouchCancel = function(evt) {
    		if ($scope.disablePanning) {
    			return;
            }

            if ($scope.lastX !== undefined) {
    		    $scope.snap();
                $scope.lastX = undefined;
            }
    	}

    	$scope.lastX = undefined;
    	$scope.lastT = undefined;
    	$scope.velocity = undefined;
    	$scope.animationStartT = undefined;
    	$scope.animationDuration = 200;
    	$scope.animationLastT = undefined;
    	$scope.animateFromX = undefined;
    	$scope.animateToX = undefined;
        $scope.moveDelta = undefined;

    	$scope.onTouchMove = function(evt) {
    		if ($scope.disablePanning) {
    			return;
    		}

            var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);

    		var touch = evt.touches[0];
    		var point = { x: touch.screenX, y: touch.screenY };
    		var now = performance.now();

    		var dx = point.x - $scope.touchStartPoint.x;
    		var dy = point.y - $scope.touchStartPoint.y;
    		var dpoint = { x: dx, y: dy };

            var newOffsetX = $scope.touchStartContentOffset.x + dpoint.x;
            var maxOffsetX = (-($scope.numPages - 1) * vw);
            var page = Math.round(Math.abs($scope.contentOffset.x / vw));

            if (newOffsetX > 0 || newOffsetX < maxOffsetX) {
                return;
            }

            if (!$scope.enabledPages[page] && dpoint.x < 0) {
                return;
            }

            if (Math.abs(dpoint.x) <= 5 && Math.abs(dpoint.y) <= 5) {
                return;
            }

            $scope.contentOffset = { x: newOffsetX, y : 0}
        	$scope.elem.style.transform = "translateX(" + $scope.contentOffset.x + "px)";

    		if ($scope.lastX !== undefined && $scope.lastT !== undefined) {
    			var dx = point.x - $scope.lastX;
    			var dt = now - $scope.lastT;
    			var velocity = dx / dt;
    			$scope.velocity = velocity;
    		}
            $scope.moveDelta = dpoint;
    		$scope.lastX = point.x;
    		$scope.lastT = performance.now();
    	}

    	$scope.snap = function() {
    		var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
			var vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

			var ofs = JSON.parse(JSON.stringify($scope.contentOffset));
			var a = ofs.x / vw;
			if (a > 0) { // Stop scrolling to the left.
				a = 0;
			}

			var page = Math.round(Math.abs(a));
			if (page > $scope.numPages - 1) {
				page = $scope.numPages - 1;
			}

            var prevPage = parseInt(page);

            if (Math.abs($scope.moveDelta.x) <= 65) {
                // Stay on the current page if we haven't moved much...
                console.log("Staying on the same page...");
			} else if ($scope.velocity > 0) { // go back
				var ceilPage = Math.ceil(Math.abs(a));
				if (page == ceilPage && Math.abs($scope.velocity) > 0.2) {
					page -= 1;
				}
			} else if ($scope.velocity < 0) { // go forward
				var floorPage = Math.floor(Math.abs(a));
				if (page == floorPage && Math.abs($scope.velocity) > 0.2) {
					page += 1;
				}
			}
			// ... again
			if (page > $scope.numPages - 1) {
				page = $scope.numPages - 1;
			}
			if (page < 0) {
				page = 0;
			}

    		$scope.animateFromX = $scope.contentOffset.x;
    		$scope.animateToX = (-page * vw);

    		$scope.animateSnap();

            $scope.$broadcast('carouselPageChange', { prevPage: prevPage, newPage: page });
    	}

    	$scope.animateSnap = function() {
    		$scope.animationStartT = performance.now();
    		$scope.requestAnimationFrame();
    	}

    	$scope.lastRequestedAnimationFrameId = undefined;
    	$scope.requestAnimationFrame = function() {
    		if ($scope.lastRequestedAnimationFrameId === undefined) {
    			$scope.lastRequestedAnimationFrameId = window.requestAnimationFrame($scope.onAnimationFrame.bind(this));
    		}
    	}

    	$scope.onAnimationFrame = function() {
    		var ok = $scope.onAnimationUpdate();

    		$scope.lastRequestedAnimationFrameId = undefined;
    		
    		if (ok) {
	    		$scope.requestAnimationFrame();
	    	}
    	}

    	$scope.onAnimationUpdate = function() {
    		var now = performance.now();
    		var	elapsed = now - $scope.animationStartT;
    		var dt = 0;
    		if ($scope.animationLastT !== undefined) {
    			dt = now - $scope.animationLastT;
    		}
 
			function EaseOutSine(t, b, c, d) {
        		return c * Math.sin(t / d * (Math.PI / 2)) + b;
			}

			var ok = true
			var t = (now - $scope.animationStartT) / $scope.animationDuration;
			var v = EaseOutSine(t, 0, 1, 1);
			if (now >= ($scope.animationStartT + $scope.animationDuration)) {
				v = 1.0;
				ok = false;
			}
                               
			var dx = ($scope.animateToX - $scope.animateFromX) * v + $scope.animateFromX;
			$scope.contentOffset = { x: dx, y: 0 };
    		$scope.elem.style.transform = "translateX(" + $scope.contentOffset.x + "px)";

    		return ok;
    	}

    	$scope.elem = angular.element(".appcarousel")[0];

		$scope.elem.addEventListener("touchstart", $scope.onTouchStart.bind(this));
		$scope.elem.addEventListener("touchend", $scope.onTouchEnd.bind(this));
		$scope.elem.addEventListener("touchcancel", $scope.onTouchCancel.bind(this));
		$scope.elem.addEventListener("touchmove", $scope.onTouchMove.bind(this));

		$scope.numPages = $scope.elem.children.length;

        $scope.pageNav = function(offset) {
            var vw = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
            var vh = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);

            var ofs = JSON.parse(JSON.stringify($scope.contentOffset));
            var a = ofs.x / vw;
            if (a > 0) { // Stop scrolling to the left.
                a = 0;
            }

            var page = Math.round(Math.abs(a));
            if (page > $scope.numPages - 1) {
                page = $scope.numPages - 1;
            }

            $scope.animateFromX = $scope.contentOffset.x;
            $scope.animateToX = (-(page + offset) * vw);

            $scope.animateSnap();

            $scope.$broadcast('carouselPageChange', { prevPage: page, newPage: (page+offset) });
        }

        $scope.prevPage = function() {
            $scope.pageNav(-1);
        }

        $scope.nextPage = function() {
            $scope.pageNav(+1);
        }

        $scope.indexOfPage = function(pageScope) {
            var n = $scope.elem.children.length;
            console.log(n);
            for (var i = 0; i < n; i++) {
                var ce = $scope.elem.children[i];
                var scope = ce.scope();
                console.log(scope);
                if (scope == pageScope) {
                    return i;
                }
            }
            return -1;
        }
    }
]);